<template>
  <div style="width: 100%; background: #fff" class="pubmed">
    <div class="pubmed-width">
      <a-spin :spinning="loading">
        <div style="margin-bottom: 20px; padding: 20px;">
          <div style="border-bottom: 1px solid #9DC3E6">
            <h3 v-if="Array.isArray(detail.abbr) && detail.abbr.length > 0">
              {{detail.abbr.join('、')}}领域文献日报 | {{detail.add_time?.split(' ')[0]}}
            </h3>
            <p>
              <small><a>Drai</a> {{detail.add_time}}</small>
            </p>
          </div>

          <div class="auto-wrap"
               style="line-height: 24px;padding: 10px 0; cursor: pointer; border-bottom: 1px solid #eee"
               v-for="(item, index) in current_data" :key="index"
          >
            <div @click="()=>goToPaper(item)">
              <p><a>{{item.title_cn }}</a></p>
              <p><i>{{item.journal_title}}</i> <span style="color:#C00000">[{{item.jif}}]</span></p>
              <p><b>{{item.summary_brief }}</b></p>
              <b>摘要: </b> <more-o-r-less :text="item.abstract_cn" len="200" :noTip="true"/>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
    import {dict2params, get_args, isDEV} from "../utils/request";
    import {
        post_biogpt_push_info, post_biogpt_skip_subscribe_info,
        post_biogpt_skip_subscribe_share_push_info
    } from "../utils/bioinfo.api";
    import {jy_tip, setState} from "../utils/vue.tool";
    import MoreORLess from '../components/MoreORLess'
    export default {
        name: "PushInfo",
        components: {
            MoreORLess
        },
        data(){
            let {keyword, push_no, subscribe_no, code} = get_args();
            return {
                loading: true,
                total_records: isDEV? 1000: 0,
                pubmed: {keyword: keyword || ''},
                push_no: Number(push_no),
                subscribe_no: Number(subscribe_no),
                subscribe_code: code,
                detail: {},
                page: 1,
                pageSize: isDEV? 1: 20,
                sortKey: 'Publish_Date',
                indeterminate: false,
                checkedList: [],
                current_data: [],
            }
        },
        created(){
            let {page, pageSize, pubmed} = this;
            let {keyword} = pubmed;
            this.get_items(page, pageSize, keyword);
        },
        methods: {
            test(){

            },
            setState(values, func){
                setState(this, values, func)
            },
            handleSubmit(values) {
                console.log(values);
                let {page, pageSize} = this;
                let {keyword} = values;
                this.get_items(page, pageSize, keyword);
            },
            get_items(page, pageSize){
                console.log(page, pageSize);
                let obj = this;
                obj.loading = true;
                let {push_no, subscribe_no, subscribe_code} = this;
                this.setState({page, pageSize}, ()=>{
                    if(! isNaN(subscribe_no))  post_biogpt_push_info({push_no, subscribe_no}, (response)=>{
                        obj.loading = false;
                        if(response){
                            let {data} = response;
                            obj.handleSort(data, data.length);
                        }
                    });
                    else if(subscribe_code){
                        // 获取标题
                        post_biogpt_skip_subscribe_info({subscribe_code}, (res)=>{
                            let {data} = res;
                            if(data) this.detail = data || {};
                            else jy_tip('获取领域异常： ' + res.message);
                        });
                        // 获取目录
                        post_biogpt_skip_subscribe_share_push_info({push_no, subscribe_code}, (response)=>{
                            obj.loading = false;
                            let {data} = response;
                            if(data) obj.handleSort(data.items, data.items.length);
                            else jy_tip('获取列表异常： ' + response.message);
                        })
                    }
                });
            },
            handleSort(data, total_records){
                data = data || [];
                let {sortKey} = this;
                if(sortKey){
                    data.sort((a, b)=>b[sortKey] - a[sortKey]);
                }
                this.setState({current_data: data, init_data: data, total_records})
            },
            goToPaper(item){
                let {paper_no} = item;
                let args = get_args();
                window.open('/push/paper?' + dict2params({...args, paper_no}));
            },
        }
    }
</script>

<style scoped>
  .auto-wrap {
    word-wrap: break-word!important; /* 旧版浏览器支持 */
    overflow-wrap: break-word!important; /* 标准属性 */
    word-break: break-all;
    /*white-space: nowrap;不换行*/
  }
  .text-wrapper {
    /* 基础设置 */
    width: 100%;
    box-sizing: border-box;

    /* 换行控制 */
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;

    /* 中文优化 */
    hyphens: auto;
    line-break: strict;

    /* 防止意外继承 */
    text-overflow: clip;
  }
  .pubmed-width{
    width: 1200px;
    margin: 10px auto;
  }
  /*{*/
  /*  xs: '480px',*/
  /*  sm: '576px',*/
  /*  md: '768px',*/
  /*  lg: '992px',*/
  /*  xl: '1200px',*/
  /*  xxl: '1600px',*/
  /*}*/
  /* 当视口宽度小于 600px 时 */
  @media (max-width: 480px) {
    .pubmed-width {
      width: 100%;
      /*border: 1px solid red;*/
      overflow-wrap: break-word!important; /* 标准属性 */
      word-break: break-all;
    }
  }
</style>
